import { useState } from 'react'
import { Avatar } from './Avatar'

interface VideoPlayerProps {
  src?: string
  fallbackMessage?: string
}

export function VideoPlayer({ src, fallbackMessage }: VideoPlayerProps) {
  const [hasError, setHasError] = useState(false)

  // Check if video file exists
  const videoExists = src && !hasError

  if (!videoExists) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-lg p-6 text-center">
        <div className="mb-4 flex justify-center">
          <Avatar size="lg" />
        </div>
        <p className="text-sm text-gray-600">
          {fallbackMessage || 'Video coming soon. The action will still work!'}
        </p>
      </div>
    )
  }

  return (
    <div className="rounded-lg overflow-hidden bg-black">
      <video
        src={src}
        controls
        autoPlay
        muted
        className="w-full"
        onError={() => setHasError(true)}
      />
    </div>
  )
}
